import React from 'react';

function Modifier(props) {
  const type = 'value modifier ' + (props.value > 0 ? 'plus' : props.value < 0 ? 'minus' : 'even');
  const output = props.value >= 0 ? '+' + props.value : props.value;
  return <span className={type}>{output}</span>;
}

export default Modifier;
